import { useEffect } from 'react'

export interface Hotkeys {
  onNew?: () => void
  onNext?: () => void
  onPrevious?: () => void
  onFit?: () => void
  onToggleHelp?: () => void
}

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable
}

/**
 * Global note navigation, suppressed while typing. Ctrl/Cmd+S is owned by the
 * editor (it needs the draft value), so it is deliberately not handled here.
 */
export function useKeyboardNav(hotkeys: Hotkeys): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return
      if (isTypingTarget(event.target)) return

      switch (event.key) {
        case 'n':
          event.preventDefault()
          hotkeys.onNew?.()
          break
        case 'j':
          event.preventDefault()
          hotkeys.onNext?.()
          break
        case 'k':
          event.preventDefault()
          hotkeys.onPrevious?.()
          break
        case 'f':
          event.preventDefault()
          hotkeys.onFit?.()
          break
        case '?':
          event.preventDefault()
          hotkeys.onToggleHelp?.()
          break
        default:
          break
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [hotkeys])
}
